import { lazy } from 'react';

const SIIEnvioPage = lazy(() => import('../../sii/envio/SIIEnvioPage.jsx'));

const siiRoutes = [
	{
		path: 'sii',
		children: [
			{ path: 'envio', element: <SIIEnvioPage /> },
		],
	},
];

export default siiRoutes;
